import { createTheme } from "@aws-amplify/ui-react";

export const amplifyTheme = createTheme({
  name: "digital-forensicist",
  tokens: {
    fonts: {
      default: {
        variable: { value: '"Inter", "Manrope", sans-serif' },
        static: { value: '"Inter", "Manrope", sans-serif' },
      },
    },
    colors: {
      brand: {
        primary: {
          10: { value: "#e6f0f3" },
          20: { value: "#b3d0d9" },
          40: { value: "#66a0b3" },
          60: { value: "#00708c" },
          80: { value: "#004152" },
          90: { value: "#003040" },
          100: { value: "#001f29" },
        },
      },
    },
    components: {
      authenticator: {
        router: {
          borderWidth: { value: "0" },
          boxShadow: { value: "none" },
        },
      },
      button: {
        primary: {
          backgroundColor: { value: "#004152" },
          color: { value: "#ffffff" },
          _hover: {
            backgroundColor: { value: "#005a70" },
          },
          _focus: {
            backgroundColor: { value: "#005a70" },
          },
          _active: {
            backgroundColor: { value: "#003040" },
          },
        },
        link: {
          color: { value: "#004152" },
          _hover: {
            color: { value: "#005a70" },
            backgroundColor: { value: "transparent" },
          },
        },
      },
      fieldcontrol: {
        borderRadius: { value: "8px" },
        _focus: {
          borderColor: { value: "#004152" },
          boxShadow: { value: "0 0 0 2px rgba(0,65,82,0.18)" },
        },
      },
      tabs: {
        item: {
          _active: {
            borderColor: { value: "#004152" },
            color: { value: "#004152" },
          },
          _hover: {
            color: { value: "#005a70" },
          },
        },
      },
    },
  },
  overrides: [
    {
      colorMode: "dark",
      tokens: {
        colors: {
          background: {
            primary: { value: "#0d1117" },
            secondary: { value: "#161b22" },
          },
          font: {
            primary: { value: "#f0f6fc" },
            secondary: { value: "#8b949e" },
            interactive: { value: "#58a6ff" },
          },
          border: {
            primary: { value: "rgba(255,255,255,0.12)" },
            secondary: { value: "rgba(255,255,255,0.08)" },
          },
        },
        components: {
          fieldcontrol: {
            borderColor: { value: "rgba(255,255,255,0.14)" },
            color: { value: "#f0f6fc" },
          },
          button: {
            primary: {
              backgroundColor: { value: "#004152" },
              color: { value: "#ffffff" },
              _hover: { backgroundColor: { value: "#005a70" } },
            },
            link: {
              color: { value: "#66a0b3" },
            },
          },
          tabs: {
            item: {
              color: { value: "#8b949e" },
              backgroundColor: { value: "transparent" },
              _active: {
                color: { value: "#f0f6fc" },
                borderColor: { value: "#004152" },
                backgroundColor: { value: "transparent" },
              },
              _hover: {
                color: { value: "#f0f6fc" },
                backgroundColor: { value: "transparent" },
              },
            },
            backgroundColor: { value: "#0d1117" },
          },
        },
      },
    },
  ],
});
